export default "__VITE_ASSET__Ir_U08jU__"